// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/scollapse/style/index.less
// module id = 546
// module chunks = 0